import React from 'react';
import ReactDOM from 'react-dom';
import { ui } from '@joint/plus';
import { Fullscreen, FullscreenExit, Map, ZoomOut } from '@mui/icons-material';

// Extension du bouton IconButton pour utiliser les icônes React

export const IconButton = ui.widgets.button.extend({
  render: function () {
    const size = this.options.size || 20;

    // Créer un conteneur pour l'icône
    let iconContainer = this.el.querySelector('.icon-container');
    if (!iconContainer) {
      iconContainer = document.createElement('div');
      iconContainer.classList.add('icon-container');
      iconContainer.style.width = `${size}px`;
      iconContainer.style.height = `${size}px`;
      this.el.appendChild(iconContainer);
    }

    this.setIcon(this.options.icon);
    this.setTooltip(this.options.tooltip);
    return this;
  },
  setIcon: function (icon = '') {
    const iconMap = {
      fullscreen: <Fullscreen />,
      'exit-fullscreen': <FullscreenExit />,
      minimap: <Map />,
      'zoom-out-min': <ZoomOut />,
    };
    const IconComponent = iconMap[icon] || null;
    if (IconComponent) {
      const iconContainer = this.el.querySelector('.icon-container');

      if (iconContainer) {
        // Vider le conteneur avant de rendre la nouvelle icône
        ReactDOM.unmountComponentAtNode(iconContainer);
        ReactDOM.render(IconComponent, iconContainer);
      } else {
        console.warn("Conteneur d'icône non trouvé.");
      }
    }
  },
  setTooltip: function (tooltip = '') {
    this.el.dataset.tooltip = tooltip;
  },
});
